<template>
    <div class="region-modal">
        <el-dialog
            :model-value="WebSkillRankingStore.isEditRegionModalOpen"
            width="700px"
            :show-close="false"
            class="custom-modal"
            @close="close"
            :title="
                ($trans('web_skill_ranking.edit_region_for') || 'Edit region for') +
                ' ' +
                (WebSkillRankingStore.activeRegionProfile?.profile_name || '')
            "
        >
            <span class="dialog-cancel-text" @click="close">
                {{ $trans("web_skill_ranking.cancel") }}
                <el-icon><Close /></el-icon>
            </span>

            <el-button
                type="primary"
                @click="save"
                :disabled="!isValidLength || loading"
            >
                {{ $trans("web_skill_ranking.save") }}
            </el-button>

            <div class="table-container">
                <el-input
                    v-model="localRegion"
                    type="textarea"
                    :rows="2"
                    maxlength="100"
                    resize="vertical"
                    :placeholder="
                        $trans('web_skill_ranking.enter_region') ||
                        'Enter custom region'
                    "
                />

                <div class="char-counter">
                    <span>{{ localRegion.length }}/100</span>&nbsp;
                    <span>
                        {{
                            $trans("web_skill_ranking.characters_used")
                        }}
                    </span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useWebSkillRankingStore } from "@/stores/WebSkillRankingStore";
import { Close } from "@element-plus/icons-vue";

export default {
    name: "EditRegionSkillRankingModal",

    components: {
        Close,
    },

    data() {
        return {
            localRegion: "",
            loading: false,
        };
    },

    computed: {
        ...mapStores(useWebSkillRankingStore),

        isValidLength() {
            return (
                this.localRegion &&
                this.localRegion.length > 0 &&
                this.localRegion.length <= 100
            );
        },
    },

    watch: {
        "WebSkillRankingStore.isEditRegionModalOpen"(value) {
            if (value) {
                const profile =
                    this.WebSkillRankingStore.activeRegionProfile;

                this.localRegion =
                    profile?.custom_region ||
                    profile?.region ||
                    profile?.country_name ||
                    "";
            }
        },
    },

    methods: {
        close() {
            this.WebSkillRankingStore.closeEditRegionModal();
        },

        async save() {
            const profile =
                this.WebSkillRankingStore.activeRegionProfile;

            if (!profile) return;

            this.loading = true;

            try {
                await this.WebSkillRankingStore.updateProfileCustomRegion(
                    profile.id,
                    this.localRegion,
                );

                this.$message.success(
                    this.$trans("web_skill_ranking.data_saved") ||
                        "Data saved successfully.",
                );

                this.close();
            } catch (error) {
                console.error(error);

                this.$message.error(
                    this.$trans(
                        "web_skill_ranking.something_went_wrong",
                    ) || "Something went wrong.",
                );
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.region-modal :deep(.el-dialog) {
    --el-dialog-width: 700px;
    top: -100px !important;
}

:deep(.el-dialog__header) {
    padding-bottom: 40px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 24px;
    padding-top: 10px;
    background-color: #ededed;
    font-family: "Barlow", sans-serif;
    padding-right: 25px;
}

:deep(.el-input) {
    width: 100%;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41abc4 !important;
    box-shadow: none !important;
}

.el-button {
    float: right;
    margin-top: -35px;
    background-color: #41abc4;
    border-color: #41abc4;
    border-radius: unset;
    width: 200px;
    font-size: 16px !important;
    font-weight: 700 !important;
}

.dialog-cancel-text {
    position: absolute;
    top: 5px;
    right: 21px;
    cursor: pointer;
    font-size: 14px;
    color: #909399;
    font-weight: 500;
    z-index: 2000;
    user-select: none;
}

.dialog-cancel-text:hover {
    color: #41abc4;
}

.dialog-cancel-text :deep(.el-icon) {
    top: 3px;
    transform: scale(1.4);
}

.char-counter {
    text-align: right;
    color: #000 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 8px;
}

:deep(.el-textarea__inner) {
    min-width: 100% !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 8px;
    min-height: 70px !important;
}

:deep(.el-dialog__title) {
    font-size: 1.5rem;
}

:deep(.el-button.is-disabled),
:deep(.el-button.is-disabled:hover),
:deep(.el-button.is-disabled:focus) {
    background-color: #bababa !important;
    border-color: #bababa !important;
    color: #ffffff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
}
</style>